import format from 'date-fns/format';

function splitHours(hours) {
    // hours format must be: '10:00 - 11:00'
    const hoursFrom = hours.replace(' ', '').split('-')[0];
    const hoursTo = hours.replace(' ', '').split('-')[1];

    return {
        from: {
            hour: hoursFrom.split(':')[0],
            min: hoursFrom.split(':')[1],
        },
        to: {
            hour: hoursTo.split(':')[0],
            min: hoursTo.split(':')[1],
        },
    }
}

function defaultHoursForDay() {
    return {
        from: { hour: 24, min: 59 },
        to: { hour: 0, min: 0 },
    };
}

function defaultHours() {
    return {
        'Monday': defaultHoursForDay(),
        'Tuesday': defaultHoursForDay(),
        'Wednesday': defaultHoursForDay(),
        'Thursday': defaultHoursForDay(),
        'Friday': defaultHoursForDay(),
        'Saturday': defaultHoursForDay(),
        'Sunday': defaultHoursForDay(),
    };
}

function getTimeString(time) {
    if (!time) {
        return '';
    }

    var hours = Math.floor(time / 60);
    var minutes = time % 60;

    if (hours < 10) hours = '0' + hours; //optional
    if (minutes < 10) minutes = '0' + minutes;

    return hours + ':' + minutes;
}

const BoutiqueHours = {

    getBoutiqueHours: function(weekHours) {
        if (!weekHours) {
            return defaultHours();
        }

        let parsedHours = [];

        weekHours.forEach((workingHours) => {
            parsedHours[workingHours.days] = splitHours(workingHours.hours);
        });

        return parsedHours;
    },

    getMinMaxBoutiqueHours: function(boutiques) {
        let hours = defaultHours();

        boutiques.forEach((boutique) => {
            Object.keys(boutique.hours).forEach((key) => {
                const day = key;
                const bHours = boutique.hours[key];

                const hoursStringFrom = (hours[day].from.hour + ':' + hours[day].from.min).replace(' ', '');
                const bHoursStringFrom = (bHours.from.hour + ':' + bHours.from.min).replace(' ', '');

                const hoursStringTo = (hours[day].to.hour + ':' + hours[day].to.min).replace(' ', '');
                const bHoursStringTo = (bHours.to.hour + ':' + bHours.to.min).replace(' ', '');

                if (hoursStringFrom > bHoursStringFrom) {
                    hours[day].from = Object.assign({}, bHours.from);
                }

                if (hoursStringTo < bHoursStringTo) {
                    hours[day].to = Object.assign({}, bHours.to);
                }
            });
        });

        return hours;
    },

    getTimesArray: function(selectedBoutique, date) {
        if (!selectedBoutique) {
            return [];
        }

        const dayOfWeek = format(date, 'dddd');
        const enabledHours = selectedBoutique ? selectedBoutique.hours[dayOfWeek] : this.getBoutiqueHours()[dayOfWeek];

        let start = [enabledHours.from.hour, enabledHours.from.min];
        let end = [enabledHours.to.hour, enabledHours.to.min];

        start = parseInt(start[0]) * 60 + parseInt(start[1]);
        end = parseInt(end[0]) * 60 + parseInt(end[1]);

        let result = [];

        for (let time = start; time <= end; time+= 15) {
            result.push(getTimeString(time));
        }

        // remove last 30min because you should not be able to make an appointment on closing hour
        if (result.length >= 2) {
            result.pop();
            result.pop();
        }

        return result;
    },
};

export default BoutiqueHours;



// WEBPACK FOOTER //
// ./scripts/util/BoutiqueHours.js